import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  //GetAllCustomersName,
  //GetProductNameCodeInv,
  GetProductByIdSale,
  //GetSaleCustomerById,
  GetSaleOrderDetailsByID,
  GetSaleOrderCustomerByID,
  DeleteEditSaleOrderProduct,
  EditSaleOrderApi,
  //RemoveProd_fromShipmentTrans,
  //GetProductByStoreID,
  //EditSaleOrderStatusBYSo_id,
  //EditSaleOrderStatus,
  getProductFilterSubString,
  //getAccNamesCash,
  GetAccToIdBySaleOrder,
  EditSpecialOrder,
  getAccNamesAssetCash,
  getAllVendorsNameByPurchaseProduct,
  // GetSaleInvoice,
  GetUnitByProductId,
  GetGenerateInvoice,
} from "../../api";
import { ValidOrderField } from "../../contexts/Utils";
import { Header } from "../../components";
import Select from "react-select";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { FcInfo } from "react-icons/fc";

const EditSaleOrder = () => {
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
    setActivePayment,
    setActivePaymentId,
    userID,
    userToken,
  } = useStateContext();
  const [ProductStr, setProductStr] = useState("");
  const [product, setProducts] = useState("");
  const [qty, setqty] = useState(1.0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productOptions, setProductOptions] = useState([]);
  const [p_code, setp_code] = useState("");
  const [customer_ids, setcustomer_ids] = useState("");
  const [CardList, setcartList] = useState([]);
  const [cardList_old, setcartList_old] = useState([]);
  const [total_amount, settotalAmount] = useState(0);
  const [tax, settax] = useState(0);
  const [totaldiscount, settotaldiscount] = useState(0.0);
  const [total_item, settotalitem] = useState(0);
  const [index1, setindex1] = useState("");
  const [grandtotal, setgrandtotal] = useState(0);
  const [note, setnote] = useState("");
  const [trackingno, settrackingno] = useState("");
  const [projectname, setprojectname] = useState("");
  const [shipmethod, setshipmethod] = useState("");
  const [cusFlag, setcusFlag] = useState("");
  const [invoice_id, setinvoice_id] = useState("");
  const [projectname2, setprojectname2] = useState(0);
  const [deleteprodList, setdeleteprodList] = useState([]);
  const [OrderStatus, setOrderStatus] = useState("");
  const [orderstatuslable, setorderstatuslable] = useState("");
  const [unshippedList, setunshippedList] = useState([]);
  const [qtyShipped, setqtyShipped] = useState([]);
  const [projectname1, setprojectname1] = useState("");
  const [acc_from_id, setacc_from_id] = useState("");
  const [amount_paid, setamount_paid] = useState(0);
  const [amount_pend, setamount_pend] = useState(0);
  const [getacc_tos, setGetacc_tos] = useState([]);
  const [acc_to_id, setacc_to_id] = useState("");
  const [acc_to, setacc_to] = useState("");
  const [acc_from_bal, setacc_from_bal] = useState("");
  const [c_type_id, setc_type_id] = useState("");
  const [paym, setpaym] = useState("");
  const [advancedMode, setAdvancedMode] = useState(0);
  const [fullShipping, setFullShipping] = useState(1);
  //const [ValError, setValError] = useState([]);
  // const [acc_to_bal, setacc_to_bal] = useState("");
  //const [productID, setproductID] = useState("");
  //const [toggle, setToggle] = useState(false);
  const [store_id_param, setstore_id_param] = useState("");
  const [dot, setdot] = useState(0);
  //const [ActiveProduct, setActiveProduct] = useState(0);
  //const [aexist, setaexist] = useState("");
  // const [name, setname] = useState("");
  const [isPageFrozen, setIsPageFrozen] = useState(false);
  //const [req_date, setreq_date] = useState();
  const [saveClick, setsaveClick] = useState(false);
  // const [ppo_id, setppo_id] = useState(0);
  const [print_flag, setprint_flag] = useState(false);
  let param = useParams();
  // console.log(param.so_ids)
  // const paramString = String(param.so_ids);
  var so_id_param = param.so_ids;
  // const [so_id_param, store_id_param] = paramString.split("_");

  const [formData] = useState({
    so_id: 0,
    est_sale: "S",
    customer_id: 0,
    customer_po_no: "",
    project_name: "",
    ship_method: "",
    tracking_no: "",
    total: 0,
    amount_paid: 0,
    amount_pending: 0,
    user_id: null,
    so_note: "",
    total_price: 0,
    discount: 0,
    tax: 0,
    status_id: 0,
    shipment: 0,
    store_id: 0,
    invoice_id: 0,
    t_type_id: 707,
    sale_products: [],
    shipments: [],
    o_datetime: "",
  });

  const [formData1, setFormData1] = useState({
    so_id: so_id_param,
    store_id: 0,
    invoice_id: 0,
    product_id: 0,
  });

  const keypadButtons = [
    "7",
    "8",
    "9",
    "4",
    "5",
    "6",
    "1",
    "2",
    "3",
    ".",
    "0",
    "00",
  ];

  const [activeInput, setActiveInput] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  //const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplier_ids, setsupplier_ids] = useState("");
  const [supplier_name, setsupplier_name] = useState("-");
  const [SupplierOptions, setSupplierOptions] = useState([]);
  const [GetSupplier, setGetSupplier] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [UnitOptions, setUnitOptions] = useState([]);
  const [GetUnit, setGetUnit] = useState([]);
  const [oDatetime, setODatetime] = useState("");

  const handleInputClick = (inputId, index) => {
    TimeoutUtility.resetTimeout();
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleSpecQtyClick = (inputId, index) => {
    TimeoutUtility.resetTimeout();
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleUnitPriceChange = (index, value) => {
    TimeoutUtility.resetTimeout();
    const newCartList = [...CardList];
    newCartList[index].unit_price = value;
    newCartList[index].total =
      value * parseFloat(newCartList[index].quantity) -
      parseFloat(newCartList[index].quantity) *
        parseFloat(newCartList[index].discount);
    setcartList(newCartList);
    setActiveInput("unit_price");
    setindex1(index);
  };

  const handleKeypadClick = (value) => {
    TimeoutUtility.resetTimeout();
    if (activeInput !== null) {
      const newCartList = [...CardList];
      const indexToUpdate = index1;
      var newValue = "0";
      if (
        activeInput === "quantity" ||
        activeInput === "unit_price" ||
        activeInput === "discount" ||
        activeInput === "shipment" ||
        activeInput === "spec_qty"
      ) {
        var currentValue = String(
          newCartList[indexToUpdate][activeInput] || ""
        );
        if (value === "." && currentValue.includes(".")) {
          return;
        }
        if (value === "." && !currentValue.includes(".")) {
          if (currentValue === "") {
            currentValue = "0";
          }
          newCartList[indexToUpdate][activeInput] = currentValue + ".0";
          setcartList(newCartList);
          setdot(1);
          return;
        }
        newValue = currentValue + String(value);
        if (dot === 1) {
          var [integerPart] = currentValue.split(".");
          if (integerPart === "") {
            integerPart = "0";
          }
          newValue = integerPart + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          newCartList[indexToUpdate][activeInput] = newValue;
          newCartList[indexToUpdate].total =
            (newCartList[indexToUpdate].unit_price -
              newCartList[indexToUpdate].discount) *
            newCartList[indexToUpdate].quantity;

          setcartList(newCartList);
          setdot(0);
        }
      } else if (activeInput === "tax" && index1 === -2) {
        var currentTaxValue = String(tax || "");

        if (value === "." && currentTaxValue.includes(".")) {
          return;
        }
        if (value === "." && !currentTaxValue.includes(".")) {
          if (currentTaxValue === "") {
            currentTaxValue = "0";
          }
          settax(currentTaxValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentTaxValue + String(value || "");
        if (dot === 1) {
          var [integerPart0] = currentTaxValue.split(".");
          if (integerPart0 === "") {
            integerPart0 = "0";
          }
          newValue = integerPart0 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          settax(newValue);
        }
      } else if (activeInput === "shipment1" && index1 === -3) {
        var currentShipmentValue = String(projectname2 || "");

        if (value === "." && currentShipmentValue.includes(".")) {
          return;
        }
        if (value === "." && !currentShipmentValue.includes(".")) {
          if (currentShipmentValue === "") {
            currentShipmentValue = "0";
          }
          setprojectname2(currentShipmentValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentShipmentValue + String(value || "");
        if (dot === 1) {
          var [integerPart1] = currentShipmentValue.split(".");
          if (integerPart1 === "") {
            integerPart1 = "0";
          }
          newValue = integerPart1 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setprojectname2(newValue);
        }
      } else if (activeInput === "amount_paid" && index1 === -4) {
        var currentAmtPaidValue = String(amount_paid || "");

        if (value === "." && currentAmtPaidValue.includes(".")) {
          return;
        }
        if (value === "." && !currentAmtPaidValue.includes(".")) {
          if (currentAmtPaidValue === "") {
            currentAmtPaidValue = "0";
          }
          setamount_paid(currentAmtPaidValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentAmtPaidValue + String(value || "");
        if (dot === 1) {
          var [integerPart2] = currentAmtPaidValue.split(".");
          if (integerPart2 === "") {
            integerPart2 = "0";
          }
          newValue = integerPart2 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setamount_paid(newValue);
          setamount_pend(grandtotal - newValue);
        }
      } else if (activeInput === "qty" && index1 === -8) {
        var currentQtyValue = String(qty || "");

        if (value === "." && currentQtyValue.includes(".")) {
          return;
        }
        if (value === "." && !currentQtyValue.includes(".")) {
          if (currentQtyValue === "") {
            currentQtyValue = "0";
          }
          setqty(currentQtyValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentQtyValue + String(value || "");
        if (dot === 1) {
          var [integerPart3] = currentQtyValue.split(".");
          if (integerPart3 === "") {
            integerPart3 = "0";
          }
          newValue = integerPart3 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setqty(newValue);
        }
      } else if (activeInput === "uprice" && index1 === -9) {
        var currentUPValue = String(unitPrice || "");

        if (value === "." && currentUPValue.includes(".")) {
          return;
        }
        if (value === "." && !currentUPValue.includes(".")) {
          if (currentUPValue === "") {
            currentUPValue = "0";
          }
          setUnitPrice(currentUPValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentUPValue + String(value || "");
        if (dot === 1) {
          var [integerPart4] = currentUPValue.split(".");
          if (integerPart4 === "") {
            integerPart4 = "0";
          }
          newValue = integerPart4 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setUnitPrice(newValue);
        }
      }
    }
  };

  const handleAddcartClick = () => {
    TimeoutUtility.resetTimeout();
    // const isProductInCart = CardList.some(
    //   (item) => item.product_id === product.value
    // );
    // if (!isProductInCart && product.value) {

    if (qty <= 0) {
      alert("Quantity should be greater than 0!");
      return;
    } else if (selectedUnit === null) {
      alert("Select Unit!");
      return;
    } else if (product.value && userID && userToken) {
      // var supp_id = null;
      // if (supplier_ids !== "" && supplier_ids !== null) {
      //   supp_id = supplier_ids;
      // }
      let qtyy = qty;
      let upp = unitPrice;
      if (selectedUnit === UnitOptions[1]) {
        qtyy = qty / selectedUnit.conv;
        upp = unitPrice / UnitOptions[0].conv;
      }
      const resp1 = GetProductByIdSale(
        p_code,
        store_id_param,
        userID,
        userToken
      );
      resp1
        .then(function (result) {
          const defaultProduct = {
            product_id: result.data[0].product_id,
            name: result.data[0].name,
            code: result.data[0].code,
            unit_price: upp,
            unit: UnitOptions[0].label,
            cost_price: result.data[0].cost_price,
            quantity: qtyy,
            item_no: 0,
            discount: result.data[0].discount,
            total: (unitPrice - result.data[0].discount) * qty,
            shipment: qtyy,
            image: result.data[0].image,
            image_url: result.data[0].image_url,
            details: result.data[0].details,
            req_delivery_date: "",
            supplier_id: supplier_ids,
            supplier_name: supplier_name,
            spec_qty: 0,
            notes: "",
          };

          setcartList((prevProductList) => [
            defaultProduct,
            ...prevProductList,
          ]);
          setProducts("");

          setProductOptions((prevOptions) =>
            prevOptions.filter(
              (option) => option.values !== result.data[0].product_id
            )
          );
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
    setSelectedProduct("");
    setSelectedSupplier(null);
    setSupplierOptions([]);
    setSelectedUnit("");
    setUnitOptions([]);
    setqty(1);
    setUnitPrice(0);
  };

  const handleChangeAdvancedMode = (e) => {
    TimeoutUtility.resetTimeout();
    setAdvancedMode((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeFullShipping = (e) => {
    TimeoutUtility.resetTimeout();
    setFullShipping((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeReqDate = (index, e) => {
    const newCartList = [...CardList];
    if (e === "undefined") {
      newCartList[index].req_delivery_date = null;
      //setreq_date(null);
    } else {
      newCartList[index].req_delivery_date = e;
      //setreq_date(e);
    }
    setcartList(newCartList);
  };

  const handleChangeUnit = (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.value) {
      if (selectedOption !== selectedUnit) {
        setUnitPrice(unitPrice / selectedOption.conv);
      }
      setSelectedUnit(selectedOption);
      setActiveInput("unit");
      document.getElementById("qty").focus();
    } else {
      // setSelectedUnit(null);
      // setActiveInput("unit");
    }
  };

  const handleChangeUnit1 = (selectedOption, event) => {
    TimeoutUtility.resetTimeout();
    if (event.key === "Enter" && selectedOption && selectedOption.value) {
      if (selectedOption !== selectedUnit) {
        setUnitPrice(unitPrice / selectedOption.conv);
      }
      setSelectedUnit(selectedOption);
      setActiveInput("unit");
      document.getElementById("qty").focus();
    } else {
      // setSelectedUnit(null);
      // setActiveInput("unit");
    }
  };

  const handleChangeSupplier = (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.value) {
      setSelectedSupplier(selectedOption);
      setActiveInput("supplier");
      setsupplier_ids(selectedOption.value);
      setsupplier_name(selectedOption.label);
    } else {
      setSelectedSupplier(null);
      setActiveInput("supplier");
      setsupplier_ids("");
      setsupplier_name("");
    }
  };

  const handleChangeSupplier1 = (selectedOption, event) => {
    if (event.key === "Enter" && selectedOption && selectedOption.value) {
      setSelectedSupplier(selectedOption);
      //setActiveInput("supplier");
      setsupplier_ids(selectedOption.value);
      setsupplier_name(selectedOption.label);
      handleAddcartClick();
      document.getElementById("product").focus();
    } else if (event.key === "Enter" && SupplierOptions.length === 0) {
      setSelectedSupplier(null);
      // setActiveInput("supplier");
      setsupplier_ids("");
      setsupplier_name("");
      handleAddcartClick();
      document.getElementById("product").focus();
    } else {
      setSelectedSupplier(null);
      setActiveInput("supplier");
      setsupplier_ids("");
      setsupplier_name("");
    }
  };

  const handleAccToChange = (e) => {
    TimeoutUtility.resetTimeout();
    setacc_to(e.target.value);
    //const acc = getacc_tos.find((item) => item.name === e.target.value);
    // console.log(acc.account_id);
    // setacc_to_bal(acc.end_balance);
    //setacc_to_id(acc.account_id);
  };

  const handleSpecQtyChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].spec_qty = value;
    setcartList(newCartList);
    setActiveInput("spec_qty");
    setindex1(index);
    // }
  };

  const handleChangeProduct = async (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.values && userID && userToken) {
      setSelectedProduct(selectedOption);
      setqty(1);
      setUnitPrice(selectedOption.price);
      await getAllVendorsNameByPurchaseProduct(
        selectedOption.values,
        userID,
        userToken
      )
        .then((resp) => {
          setGetSupplier(resp.data || []);
        })
        .catch((err) => {
          console.log(err.message);
        });
      await GetUnitByProductId(selectedOption.values, userID, userToken)
        .then((resp) => {
          setGetUnit(resp.data || []);
        })
        .catch((err) => {
          console.log(err.message);
        });
      var ProductStr1 = ProductStr;
      ProductStr1 = ProductStr1 + selectedOption.values + " ";
      setProductStr(ProductStr1);
      setActiveInput("product");
      setProducts(selectedOption);
      const selectedProduct = selectedOption.values;
      setp_code(selectedProduct);
      document.getElementById("unit").focus();
    }
  };

  const handleChangeNote = (e) => {
    setnote(e.target.value);
  };

  const handleChangeAmountPaid = (e) => {
    setActiveInput("amount_paid");
    setamount_paid(e.target.value);
    setamount_pend(grandtotal - e.target.value);
    setindex1(-4);
  };

  const handleChangeProjectName2 = (e) => {
    setActiveInput("shipment1");
    setprojectname2(e.target.value);
    setindex1(-3);
  };

  const handleChangeProjectName1 = (e) => {
    setprojectname1(e.target.value);
  };

  const handleChangeProjectName = (e) => {
    setprojectname(e.target.value);
  };

  const handleChangeTrackingNo = (e) => {
    settrackingno(e.target.value);
  };

  const handleChangeShipMethod = (e) => {
    setshipmethod(e.target.value);
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  const handleInputChange = (inputValue) => {
    if (customer_ids) {
      if (inputValue && inputValue.length >= 2 && userID && userToken) {
        const searchResults = getProductFilterSubString(
          store_id_param,
          inputValue,
          ProductStr,
          userID,
          userToken
        );
        searchResults
          .then((response) => {
            const productsArray = response.data;
            // const filteredProducts = productsArray.filter(
            //   (product) =>
            //     !CardList.some((item) => item.product_id === product.product_id)
            // );
            //const newProductOptions = filteredProducts.map((item) => ({
            const filteredProducts = productsArray.filter(
              (product) =>
                new Date(product.open_datetime) <= new Date(oDatetime)
            );
            addProductToOptions(filteredProducts);
          })
          .catch((error) => {
            console.error("Error fetching products:", error);
          });
      } else {
        // setProductOptions(productOptions1);
      }
    }
  };

  const addProductToOptions = (prodArr) => {
    const newProductOptions = prodArr.map((item) => ({
      values: item.product_id,
      price: item.unit_price,
      last_so_info:
        "Last Price: " +
        (item.last_price || "-") +
        " - SO#" +
        (item.last_so_id || "-") +
        " - SaleDate: " +
        (item.last_sale_date
          ? new Date(item.last_sale_date).toISOString().split("T")[0]
          : "-"),
      value: `${item.code} ${item.productname} ${item.details} ${formatCurrency(
        item.unit_price
      )}`.toLowerCase(),
      label: (
        <div
          style={{
            display: "flex",
            marginTop: "4px",
          }}
        >
          {defaultImageMode && imageMode && (item.image || item.image_url) && (
            <div
              style={{
                flex: "0 0 10%",
              }}
            >
              <img
                className="rounded-xl"
                src={
                  item.image_url
                    ? `${item.image_url}`
                    : `data:image/jpeg;base64,${item.image}`
                }
                alt={`Product ${item.code}`}
                style={{
                  maxWidth: "50px",
                  height: "50px",
                  objectFit: "cover",
                }}
              />
            </div>
          )}
          <div
            style={{
              flex:
                defaultImageMode && imageMode && (item.image || item.image_url)
                  ? "0 0 76%"
                  : "0 0 86%",
              paddingLeft: "0px",
            }}
          >
            <div>
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>{`${
                item.code
              } ${truncate(
                item.productname,
                defaultImageMode && imageMode && (item.image || item.image_url)
                  ? 44
                  : 50
              )}`}</div>
            </div>
            <div style={{ fontSize: "14px" }}>{`${truncate(
              item.details,
              defaultImageMode && imageMode && (item.image || item.image_url)
                ? 60
                : 68
            )}`}</div>
          </div>
          <div
            style={{
              flex: "0 0 14%",
              fontWeight: "500",
              color: currentColor,
              textAlign: "right",
              verticalAlign: "middle",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: "calc(0.6vw + 4px)",
            }}
          >{`${formatCurrency(item.unit_price)}`}</div>
        </div>
      ),
    }));
    setProductOptions(newProductOptions);
  };

  const customFilter = (option, inputValue) => {
    const optionSearchField = String(option.value).toLowerCase();
    const lowerCasedInput = inputValue.toLowerCase();
    return optionSearchField.includes(lowerCasedInput);
  };

  const handleSaleOrderClick = async (e) => {
    TimeoutUtility.resetTimeout();
    if (CardList.length === 0) {
      alert("Sales order cart is empty.");
      return;
    }
    //console.log(unshippedList);
    setIsPageFrozen(true);
    setsaveClick(!saveClick);
  };

  const handlePrintOrderClick = async (e) => {
    setprint_flag(true);
    handleSaleOrderClick();
  };

  useEffect(() => {
    async function SaveOrder() {
      if (saveClick && userID && userToken) {
        const updatedFormData = { ...formData };
        updatedFormData.so_id = so_id_param;
        updatedFormData.est_sale = "S";
        updatedFormData.customer_id = customer_ids;
        updatedFormData.customer_po_no = projectname1;
        updatedFormData.total = grandtotal;
        updatedFormData.amount_pending = grandtotal - amount_paid;
        updatedFormData.amount_paid = amount_paid;
        updatedFormData.so_note = note;
        updatedFormData.total_price = grandtotal;
        updatedFormData.tax = tax;
        updatedFormData.discount = totaldiscount;
        updatedFormData.tracking_no = trackingno;
        updatedFormData.project_name = projectname;
        updatedFormData.ship_method = shipmethod;
        updatedFormData.invoice_id = invoice_id;
        updatedFormData.store_id = store_id_param;
        updatedFormData.shipment = projectname2;
        updatedFormData.o_datetime = oDatetime.replace("T", " ");
        updatedFormData.acc_from_id = acc_from_id;
        updatedFormData.acc_to_id = acc_to_id;
        updatedFormData.user_id = userID;

        updatedFormData.sale_products = [];
        updatedFormData.shipments = [];
        var specOrder = {
          products: [],
          remove_products: [],
        };

        if (OrderStatus === "MARK AS OPEN") {
          updatedFormData.status_id = 81;
        } else {
          updatedFormData.status_id = 80;
        }
        //console.log(CardList);
        var ff = 0,
          xx = null;
        const uniqueValues = new Set(
          CardList.map((v) => String(v.product_id) + v.notes)
        );

        if (uniqueValues.size < CardList.length) {
          //console.log(uniqueValues);
          alert(
            `Duplicate notes for same products found.\nSales Order failed to create.`
          );
          setsaveClick(!saveClick);
          setIsPageFrozen(false);
          return;
        } else {
          CardList.forEach((product) => {
            const qtyShippedProduct = qtyShipped.find(
              (item) => parseInt(item.item_no) === parseInt(product.item_no)
            );
            // const shipprod = unshippedList.find(
            //   (item) => parseInt(item.item_no) === parseInt(product.item_no)
            // );
            // console.log(qtyShippedProduct);
            // console.log(shipprod);
            // console.log("Product:", qtyShipped);
            // console.log("QtyShippedProduct:", unshippedList);
            if (fullShipping === 1) {
              if (
                parseFloat(product.shipment) <= parseFloat(product.quantity)
              ) {
                if (qtyShippedProduct) {
                  const shippedQuantity =
                    parseFloat(product.quantity) -
                    parseFloat(qtyShippedProduct.shipment);
                  // console.log(
                  //   parseFloat(qtyShippedProduct.shipment),
                  //   parseFloat(product.quantity),
                  //   parseFloat(product.shipment)
                  // );
                  // if (shippedQuantity !== 0) {
                  const shipment = {
                    product_id: product.product_id,
                    s_quantity: product.quantity,
                    quantity_shipped: shippedQuantity,
                    shipped_note: product.notes,
                    old_unit_price: qtyShippedProduct.unit_price,
                    old_discount: qtyShippedProduct.discount,
                    old_qty_ship: qtyShippedProduct.shipment,
                  };
                  updatedFormData.shipments.push(shipment);
                  // }
                } else {
                  const shipment = {
                    product_id: product.product_id,
                    s_quantity: product.quantity,
                    quantity_shipped: product.quantity,
                    shipped_note: product.notes,
                    old_unit_price: 0,
                    old_discount: 0,
                    old_qty_ship: 0,
                  };
                  updatedFormData.shipments.push(shipment);
                }
              } else {
                if (ff === 0) {
                  //console.log(product);
                  xx = product.code;
                  ff = 1;
                }
              }
              //} else if (parseFloat(product.shipment) > 0 || shipprod) {
            } else {
              if (
                parseFloat(product.shipment) <= parseFloat(product.quantity)
              ) {
                if (qtyShippedProduct) {
                  const shippedQuantity =
                    parseFloat(product.shipment) -
                    parseFloat(qtyShippedProduct.shipment);
                  //console.log(parseFloat(qtyShippedProduct.shipment));
                  //if (shippedQuantity !== 0) {
                  const shipment = {
                    product_id: product.product_id,
                    s_quantity: product.quantity,
                    quantity_shipped: shippedQuantity,
                    shipped_note: product.notes,
                    old_unit_price: qtyShippedProduct.unit_price,
                    old_discount: qtyShippedProduct.discount,
                    old_qty_ship: qtyShippedProduct.shipment,
                  };
                  updatedFormData.shipments.push(shipment);
                  //}
                } else {
                  const shipment = {
                    product_id: product.product_id,
                    s_quantity: product.quantity,
                    quantity_shipped: product.shipment,
                    shipped_note: product.notes,
                    old_unit_price: 0,
                    old_discount: 0,
                    old_qty_ship: 0,
                  };
                  updatedFormData.shipments.push(shipment);
                }
              } else {
                if (ff === 0) {
                  xx = product.code;
                  ff = 1;
                }
              }
            }
            var dt = null;
            if (
              product.req_delivery_date !== null ||
              product.req_delivery_date !== ""
            ) {
              dt = product.req_delivery_date.replace("T", " ");
            }
            const saleProduct = {
              product_id: product.product_id,
              supplier_id: product.supplier_id,
              item_no: product.item_no,
              quantity: product.quantity,
              price: product.unit_price,
              cost_price: product.cost_price,
              item_note: product.notes,
              discount: product.discount,
              req_delivery_date: dt,
            };
            updatedFormData.sale_products.push(saleProduct);
          });
          if (ff === 1) {
            alert(
              `Ship qty of ${xx} must be less or equal to total qty.\nSales Order failed to update.`
            );
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }
          //console.log(updatedFormData);
          ff = 0;

          // if (!ppo_id) {
          CardList.forEach((product, index) => {
            var dt = "",
              qq = 10;
            const prodexist = cardList_old.find(
              (item) =>
                item.product_id === product.product_id &&
                item.item_no === product.item_no
            );
            var t = 1;
            if (prodexist) {
              t = parseFloat(prodexist.spec_qty);
            }
            const sty = qtyShipped.find(
              (item) =>
                parseInt(item.product_id) === parseInt(product.product_id) &&
                item.item_no === product.item_no
            );
            if (sty) {
              if (
                parseFloat(sty.spec_qty) > 0 &&
                parseFloat(product.spec_qty) === 0
              ) {
                const spec_prd = {
                  product_id: product.product_id,
                  item_no: product.item_no,
                  so_id: so_id_param,
                };
                specOrder.remove_products.push(spec_prd);
              }
            }

            if (
              (parseFloat(product.spec_qty) >= 0 && t > 0) ||
              product.spec_qty > 0
            ) {
              if (product.req_delivery_date) {
                dt = product.req_delivery_date.replace("T", " ");
              }
              if (
                parseFloat(product.spec_qty) <= parseFloat(product.quantity)
              ) {
                const qtyShippedProduct = qtyShipped.find(
                  (item) =>
                    parseInt(item.product_id) ===
                      parseInt(product.product_id) &&
                    item.item_no === product.item_no
                );
                const shipprod = unshippedList.find(
                  (item) =>
                    parseInt(item.product_id) ===
                      parseInt(product.product_id) &&
                    item.item_no === product.item_no
                );

                if (parseFloat(product.shipment) > 0 || shipprod) {
                  if (
                    parseFloat(product.shipment) <= parseFloat(product.quantity)
                  ) {
                    if (qtyShippedProduct) {
                      const shippedQuantity =
                        parseFloat(product.shipment) -
                        parseFloat(qtyShippedProduct.shipment);
                      //console.log(parseFloat(qtyShippedProduct.shipment));
                      if (shippedQuantity !== 0) {
                        if (
                          parseFloat(product.shipment) >=
                          parseFloat(product.spec_qty)
                        ) {
                          qq = 13;
                        }
                      }
                    }
                  }
                }

                const Specproduct = {
                  product_id: product.product_id,
                  so_id: so_id_param,
                  quantity_req: product.spec_qty,
                  quantity_order: 0,
                  status_id: qq,
                  item_no: product.item_no,
                  req_delivery_date: dt,
                  note: product.notes,
                };
                specOrder.products.push(Specproduct);
              } else {
                if (ff === 0) {
                  xx = product.code;
                  ff = 1;
                }
              }
            }
          });
          if (ff === 1) {
            alert(
              `Special order qty of ${xx} must be less or equal to total qty.\nSales Order failed to update.`
            );
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }
          // }

          // setFormData(updatedFormData);
          if (deleteprodList.length === 0) {
          } else {
            DeleteProductfrom_SaleOrder();
          }

          // if (unshippedList.length === 0) {
          // } else {
          //   DeleteUnshippedProductsfrom_SaleOrder();
          // }

          const response = await EditSaleOrderApi(
            updatedFormData,
            userID,
            userToken
          );
          if (response.status === 200) {
            if (
              print_flag &&
              so_id_param &&
              store_id_param &&
              userID &&
              userToken
            ) {
              //await openNewTab(so_id_param);
              const res1 = await GetGenerateInvoice(
                store_id_param,
                so_id_param,
                "New",
                userID,
                userToken
              );
              if (res1.data) {
                const pdfBlob = new Blob([res1.data], {
                  type: "application/pdf",
                });
                const pdfURL = URL.createObjectURL(pdfBlob);
                const newWindow = window.open(pdfURL);
                if (newWindow) {
                  // Wait for PDF to load, then print
                  newWindow.addEventListener("load", () => {
                    newWindow.focus();
                    newWindow.print();
                  });
                }
              }
              alert("Sales order updated successfully.");
              setprint_flag(false);
            }
            // if (orderstatuslable === "OPEN") {
            //   // console.log(response.data[0][0].so_id)
            //   if (so_id_param) {
            //     // console.log(response.data[0][0].so_id)
            //     UpdateStatus(80, so_id_param);
            //   } else {
            //     UpdateStatus(81, so_id_param);
            //   }
            // } else {
            //   // return;
            // }
            if (!print_flag) {
              alert("Sales order updated successfully.");
            }
          } else {
            alert("Sales order failed to update.");
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }

          // if (!ppo_id) {
          if (specOrder.products.length > 0) {
            //console.log(specOrder);
            const resp = await EditSpecialOrder(specOrder, userID, userToken);
            if (resp.status === 200) {
              //console.log(resp.data);
              if (resp.data.id) {
              } else {
                setsaveClick(!saveClick);
                setIsPageFrozen(false);
                alert("Special qty failed to update.");
                return;
              }
            } else {
              alert("Special qty failed to update.");
              setsaveClick(!saveClick);
              setIsPageFrozen(false);
              return;
            }
          }
          //}

          setsaveClick(!saveClick);
          setIsPageFrozen(false);
          window.location.reload();
        }
      }
    }
    SaveOrder();
    // eslint-disable-next-line
  }, [saveClick]);

  const handleStatusClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (CardList.length === 0) {
      alert("Sales order cart is empty.");
      return;
    }
    if (orderstatuslable === "CLOSE") {
      // if (window.confirm(`Order is already closed.\nStill want to continue?`)) {
      setOrderStatus("MARK AS CLOSE");
      setorderstatuslable("OPEN");
      return;
      // } else {
      //   // return;
      // }
    } else {
      if (orderstatuslable === "OPEN") {
        let f = 0;
        CardList.forEach((element) => {
          if (!(parseInt(element.quantity) <= parseInt(element.shipment))) {
            f = 1;
          } else {
            setOrderStatus("MARK AS OPEN");
            setorderstatuslable("CLOSE");
            return;
          }
        });
        if (f === 1) {
          if (
            window.confirm(
              `Quantity is not completely shipped.\nStill want to continue?`
            )
          ) {
            setOrderStatus("MARK AS OPEN");
            setorderstatuslable("CLOSE");
            return;
          }
        }
      }
    }
  };

  const handleClearClick = async (event) => {
    TimeoutUtility.resetTimeout();
    if (window.confirm(`Are you sure you want to Clear the sale order?`)) {
      window.location.reload();
    }
  };

  const handleToggle = (value) => {
    TimeoutUtility.resetTimeout();
    // console.log(value);
    // setToggle((pre) => !pre);
    // if (!viewOrderProductOpen) {
    //   openViewOrderProduct();
    // }
    setActiveProdMenuId({
      product_id: value.product_id,
      store_id: store_id_param,
    });
    setActivePayment(false);
    setActiveProdMenu(true);
    //setproductID(value.product_id);
  };

  const handlePaymentToggle = () => {
    TimeoutUtility.resetTimeout();
    // console.log(so_id_param);
    setActivePaymentId({
      so_id: so_id_param,
      po_id: null,
    });
    setActiveProdMenu(false);
    setActivePayment(true);
  };

  const handleNewClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    try {
      //console.log("Add new");
      const path = `/Sales/AddSaleOrder/${store_id_param}`;
      window.open(path, "_blank");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const CalculateAllFields = () => {
    let total_amt = 0,
      total_itm = 0;
    let total_dis = 0;
    let grandTotal = 0.0;
    let taxx = 0,
      dd = 0;

    if (tax) {
      taxx = parseFloat(tax);
    }

    for (let i = 0; i < CardList.length; i++) {
      let a = 0,
        b = 0,
        c = 0;
      if (CardList[i].total) {
        a = parseFloat(CardList[i].total);
      }
      if (CardList[i].discount) {
        b = parseFloat(CardList[i].discount);
      }
      if (CardList[i].quantity) {
        c = parseFloat(CardList[i].quantity);
      }
      if (projectname2) {
        dd = parseFloat(projectname2);
      }
      total_amt = total_amt + a + b * c;
      total_dis = total_dis + b * c;
      total_itm = total_itm + c;
    }
    settotaldiscount(total_dis);
    settotalAmount(total_amt);
    settotalitem(total_itm);
    taxx = (taxx / 100) * (total_amt - total_dis);
    grandTotal = total_amt - total_dis + taxx + dd;
    setgrandtotal(grandTotal);
    setamount_pend(grandTotal - amount_paid);

    if (paym === 0) {
      if (c_type_id === 1600) {
        //setamount_paid(grandTotal);
        //setamount_pend(0);
      } else {
        //setamount_paid(0);
        //setamount_pend(grandTotal);
      }
    }
  };

  const handleNotesChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].notes = value;
    setcartList(newCartList);
    setActiveInput("notes");
    setindex1(index);
  };

  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    if (
      window.confirm(
        `Are you sure you want to Close without saving the changes?`
      )
    ) {
      window.close();
    }
  };

  const handleShipmentClick = (inputId, index) => {
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleShipmentChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].shipment = value;
    setcartList(newCartList);
    setActiveInput("shipment");
    setindex1(index);
  };

  const handleQuantityChange = (index, value) => {
    TimeoutUtility.resetTimeout();
    const newCartList = [...CardList];
    if (!ValidOrderField(value)) {
      if (value !== "") {
        newCartList[index].quantity = 0;
        newCartList[index].shipment = 0;
        newCartList[index].total =
          value * parseFloat(newCartList[index].unit_price) -
          value * parseFloat(newCartList[index].discount);
        setcartList(newCartList);
        setActiveInput("quantity");
        setindex1(index);
        return;
      }
    }
    newCartList[index].quantity = value;
    newCartList[index].shipment = value;
    newCartList[index].total =
      value * parseFloat(newCartList[index].unit_price) -
      value * parseFloat(newCartList[index].discount);
    setcartList(newCartList);
    setActiveInput("quantity");
    setindex1(index);
  };

  const handleDiscountChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].discount = value;
    newCartList[index].total =
      newCartList[index].quantity * newCartList[index].unit_price -
      newCartList[index].quantity * value;
    setcartList(newCartList);
    setActiveInput("discount");
    setindex1(index);
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    });
  };

  const handleChangeTax = (e) => {
    setActiveInput("tax");
    settax(e.target.value);
    setindex1(-2);
  };

  const handleChangeQty = (e) => {
    setActiveInput("qty");
    setqty(e.target.value);
    //setindex1(-2);
  };

  const handleEnterQty = (e) => {
    if (e.key === "Enter") {
      document.getElementById("uprice").focus();
    }
  };

  const handleChangeUPrice = (e) => {
    setActiveInput("uprice");
    setUnitPrice(e.target.value);
    //setindex1(-2);
  };

  const handleEnterUPrice = (e) => {
    if (e.key === "Enter") {
      document.getElementById("supplier").focus();
    }
  };

  const DeleteProductfrom_SaleOrder = async () => {
    const updatedFormData = { ...formData1 };
    updatedFormData.store_id = store_id_param;
    updatedFormData.invoice_id = invoice_id;
    setFormData1(updatedFormData);

    try {
      await Promise.all(
        deleteprodList.map(async (item) => {
          if (item.item_no !== 0 && userID && userToken) {
            const deleteFormData = {
              ...updatedFormData,
              product_id: item.product_id,
              item_no: item.item_no,
            };
            const response = await DeleteEditSaleOrderProduct(
              deleteFormData,
              userID,
              userToken
            );

            if (response.status !== 200) {
              console.error(`Product ${item.product_id} failed to remove.`);
            }
          }
        })
      );
    } catch (error) {
      console.error("Error during product removal:", error);
      alert("An error occurred during product removal.");
    }
  };

  const handleDeleteClick = async (index) => {
    TimeoutUtility.resetTimeout();
    const removedProduct = CardList[index];
    if (removedProduct.shipment === 0) {
      if (removedProduct.spec_qty === 0) {
        if (
          window.confirm(
            `Do you want to remove ${removedProduct.code} from cart?`
          )
        ) {
          setdeleteprodList((prevArray) => [
            ...prevArray,
            {
              product_id: removedProduct.product_id,
              item_no: removedProduct.item_no,
            },
          ]);
          const item1 = CardList[index].product_id;
          const newCartList = [...CardList];
          newCartList.splice(index, 1);
          setcartList(newCartList);

          const currentIdsArray = ProductStr.split(" ");
          const updatedIdsArray = currentIdsArray.filter(
            (id) => id !== String(item1)
          );
          const updatedProductIds = updatedIdsArray.join(" ");
          setProductStr(updatedProductIds);
        }
      } else {
        alert(
          "Special order qty is greater than zero. So, it could not be deleted."
        );
      }
    } else {
      alert("Ship qty is greater than zero. So, it could not be deleted.");
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (
        store_id_param &&
        store_id_param !== "" &&
        oDatetime &&
        oDatetime !== "" &&
        userID &&
        userToken
      ) {
        await getAccNamesAssetCash(store_id_param, userID, userToken)
          .then((resp) => {
            if (resp.data.length > 0) {
              const filteredAccTos = resp.data.filter(
                (item) => new Date(item.open_datetime) <= new Date(oDatetime)
              );
              setGetacc_tos(filteredAccTos);
            }
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [store_id_param, oDatetime, userID, userToken]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    if (getacc_tos.length > 0) {
      const acc = getacc_tos.find((item) => item.name === acc_to);
      //console.log(acc);
      // setacc_to_bal(acc.end_balance);
      if (acc) {
        setacc_to_id(acc.account_id);
      } else {
        setacc_to_id(getacc_tos[0].account_id);
        setacc_to(getacc_tos[0].name);
      }
    } else {
      setacc_to_id(null);
    }
  }, [acc_to, getacc_tos]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (so_id_param && userID && userToken) {
        await GetAccToIdBySaleOrder(so_id_param, userID, userToken)
          .then((resp) => {
            setacc_from_bal(resp.data[0].end_balance);
            if (resp.data[0].name === "N/A") {
              setacc_to("");
            } else {
              setacc_to(resp.data[0].name);
            }
          })
          .catch((err) => {
            console.log(err.message);
          });

        await GetSaleOrderCustomerByID(so_id_param, userID, userToken)
          .then((resp) => {
            setstore_id_param(resp.data[0].store_id);
            setcusFlag(resp.data[0].name);
            setcustomer_ids(resp.data[0].customer_id);
            setprojectname1(resp.data[0].customer_po_no);
            settrackingno(resp.data[0].tracking_no);
            setprojectname(resp.data[0].project_name);
            setshipmethod(resp.data[0].ship_method);
            settax(resp.data[0].tax);
            setnote(resp.data[0].so_note);
            setinvoice_id(resp.data[0].invoice_id);
            setprojectname2(resp.data[0].shipment);
            setamount_paid(resp.data[0].amount_paid);
            setamount_pend(resp.data[0].amount_pend);
            setc_type_id(resp.data[0].type_id);
            setpaym(resp.data[0].payment);
            setacc_from_id(resp.data[0].account_id);
            if (resp.data[0].status_id === 81) {
              setOrderStatus("MARK AS OPEN");
              setorderstatuslable("CLOSE");
            } else {
              setOrderStatus("MARK AS CLOSE");
              setorderstatuslable("OPEN");
            }
            var d1 = new Date(resp.data[0].sale_date);
            d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());
            setODatetime(d1.toISOString().slice(0, 19));
          })
          .catch((err) => {
            console.log(err.message);
          });

        await GetSaleOrderDetailsByID(so_id_param, userID, userToken).then(
          function (result) {
            if (result.data) {
              const productList = result.data.map((item) => {
                var reqDelDate = "";
                if (item.req_delivery_date) {
                  reqDelDate = new Date(item.req_delivery_date);
                  reqDelDate.setMinutes(
                    reqDelDate.getMinutes() - reqDelDate.getTimezoneOffset()
                  );
                  reqDelDate = reqDelDate.toISOString().slice(0, 19);
                }
                return {
                  product_id: item.product_id,
                  name: item.product_name,
                  code: item.code,
                  unit_price: item.unit_price,
                  unit: item.unit,
                  cost_price: item.cost_price,
                  quantity: item.quantity,
                  discount: item.discount,
                  total: (item.unit_price - item.discount) * item.quantity,
                  item_no: item.item_no,
                  shipment: item.product_shipped,
                  image: item.image,
                  image_url: item.image_url,
                  details: item.details,
                  notes: item.item_note,
                  req_delivery_date: reqDelDate,
                  supplier_id: item.vendor_id,
                  supplier_name: item.vendor,
                  spec_qty: item.quantity_req,
                };
              });

              setcartList(() => [...productList]);
              setcartList_old((prevProductList) => [
                ...prevProductList,
                ...productList,
              ]);

              const qtyShippedList = productList.map((product) => ({
                product_id: product.product_id,
                shipment: product.shipment,
                spec_qty: product.spec_qty,
                unit_price: product.unit_price,
                discount: product.discount,
                item_no: product.item_no,
                notes: product.notes,
              }));

              setqtyShipped((prevQtyShippedList) => [
                ...prevQtyShippedList,
                ...qtyShippedList,
              ]);
              const unshippedSet = new Set();

              productList.forEach((product, index) => {
                if (product.shipment > 0) {
                  unshippedSet.add({
                    product_id: product.product_id,
                    item_no: product.item_no,
                  });
                }
              });
              const unshippedArray = Array.from(unshippedSet);
              setunshippedList(unshippedArray);
            }
          }
        );
      }
    }
    fetchData();
  }, [so_id_param, userID, userToken]);

  useEffect(() => {
    const fetchSupplierOptions = async () => {
      if (GetSupplier) {
        const fetchedSupplierOption = GetSupplier.map((item) => ({
          label: `${item.vendor}`,
          value: item.vendor_id,
        }));
        setSupplierOptions(fetchedSupplierOption);
        setSelectedSupplier(fetchedSupplierOption[0]);
        if (fetchedSupplierOption[0]) {
          setsupplier_ids(fetchedSupplierOption[0].value);
          setsupplier_name(fetchedSupplierOption[0].label);
        }
      }
    };
    fetchSupplierOptions();
  }, [GetSupplier]);

  useEffect(() => {
    const fetchUnitOptions = async () => {
      if (GetUnit && GetUnit.length > 0) {
        const fetchedOption = [];
        fetchedOption.push({
          label: `${GetUnit[0].name}`,
          value: GetUnit[0].unit_id,
          conv: parseFloat(GetUnit[0].conv_rate),
        });
        if (GetUnit[0].parent) {
          fetchedOption.push({
            label: `${GetUnit[0].pname}`,
            value: GetUnit[0].parent,
            conv: 1 / parseFloat(GetUnit[0].conv_rate),
          });
        }
        setUnitOptions(fetchedOption);
        if (fetchedOption[0]) {
          setSelectedUnit(fetchedOption[0]);
        }
      }
    };
    fetchUnitOptions();
  }, [GetUnit]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    CalculateAllFields();
  }, [CardList, tax, projectname2]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: "70px",
      height: "70px",
      fontSize: "14px",
    }),
    option: (provided) => ({
      ...provided,
      maxHeight: "70px",
      fontSize: "14px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "250px",
    }),
  };

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      {isPageFrozen && <div className="overlay-freeze" />}
      <Container fluid className="g-0 p-0 justify-end">
        <Row
          xs={1}
          sm={1}
          className="justify-content-center"
          style={{ padding: "0" }}
        >
          <Col md={7} className="container-col">
            <Header title="EDIT SALES ORDER" />
          </Col>
          <Col md={2} className="container-col">
            <label className="label" style={{ fontSize: "12px" }}>
              <span style={{ paddingLeft: "8px" }}>Sales Order DateTime:</span>
            </label>
            <input
              disabled
              className="input"
              id="o_date"
              type="datetime-local"
              style={{
                textAlign: "left",
                fontSize: "12px",
                width: "178px",
                background: "lightgray",
              }}
              value={oDatetime}
            />
          </Col>
          <Col md={3} className="container-col">
            <label
              style={{
                marginLeft: "32px",
                fontWeight: "bold",
                fontSize: "18px",
                backgroundColor: currentColor,
                color: "white",
                padding: "4px",
                paddingLeft: "8px",
                paddingRight: "8px",
                borderRadius: "5px",
              }}
            >
              ORDER STATUS: {orderstatuslable}
            </label>
            <label
              style={{
                marginLeft: "32px",
                fontWeight: "bold",
                fontSize: "18px",
                backgroundColor: currentColor,
                color: "white",
                padding: "4px",
                paddingLeft: "8px",
                paddingRight: "8px",
                borderRadius: "5px",
              }}
            >
              SO# {so_id_param}
            </label>
          </Col>
        </Row>
        <Row
          xs={1}
          sm={1}
          className="justify-content-center"
          style={{ padding: "0" }}
        >
          <Col md={9} className="container-col">
            <div className="card-sale">
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0" }}
              >
                <Col md={12} className="container-col">
                  <label className="label" style={{ fontSize: "18px" }}>
                    Customer:
                  </label>
                  <div className="sale-input-div">
                    <div className="sale-input">
                      <input
                        className="input"
                        style={{ width: "100%", height: "36px" }}
                        type="text"
                        value={cusFlag}
                        readOnly
                        disabled
                      />
                    </div>
                    <div
                      className="sale-bal ml-4"
                      style={{ backgroundColor: currentColor }}
                    >
                      <label>{formatCurrency(acc_from_bal)}</label>
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0" }}
              >
                <Col md={12} className="container-col">
                  <div style={{ display: "flex" }}>
                    <label
                      htmlFor="product"
                      className="label"
                      style={{ fontSize: "18px", flex: "46%" }}
                    >
                      Product:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "11%" }}
                    >
                      Unit:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "8.5%" }}
                    >
                      Quantity:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "8.5%" }}
                    >
                      Price:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "26%" }}
                    >
                      Supplier:
                    </label>
                  </div>
                  <div className="sale-input-div">
                    <div className="sale-input">
                      <Select
                        className="myreact-select-prod"
                        inputId="product"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedProduct}
                        onChange={handleChangeProduct}
                        options={productOptions}
                        isSearchable
                        placeholder="Search Product With Name / Code"
                        styles={customStyles}
                        filterOption={customFilter}
                        onInputChange={handleInputChange}
                      />
                      <Select
                        className="myreact-select-unit"
                        inputId="unit"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedUnit}
                        onChange={handleChangeUnit}
                        options={UnitOptions}
                        isSearchable
                        placeholder="Unit"
                        styles={customStyles}
                        onKeyDown={(event) =>
                          handleChangeUnit1(selectedUnit, event)
                        }
                      />
                      <input
                        id="qty"
                        type="number"
                        step="1"
                        min="0"
                        max="1000000"
                        className="input myreact-select-prod-qty"
                        value={qty}
                        placeholder="Quantity"
                        onClick={() => handleInputClick("qty", -8)}
                        onChange={handleChangeQty}
                        onKeyDown={handleEnterQty}
                      />
                      <input
                        id="uprice"
                        type="number"
                        step="1"
                        min="0"
                        max="1000000"
                        className="input myreact-select-prod-price"
                        value={unitPrice}
                        placeholder="Unit Price"
                        onClick={() => handleInputClick("uprice", -9)}
                        onChange={handleChangeUPrice}
                        onKeyDown={handleEnterUPrice}
                      />
                      <Select
                        className="myreact-select-supp"
                        inputId="supplier"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedSupplier}
                        onChange={handleChangeSupplier}
                        options={SupplierOptions}
                        isSearchable
                        placeholder="Product Supplier"
                        isClearable
                        styles={customStyles}
                        onKeyDown={(event) =>
                          handleChangeSupplier1(selectedSupplier, event)
                        }
                      />
                    </div>
                    <button
                      className="sale-bal ml-4"
                      type="button"
                      style={{
                        backgroundColor: currentColor,
                        fontWeight: "1000",
                        fontSize: "18px",
                        height: "100%",
                      }}
                      onClick={handleAddcartClick}
                    >
                      +
                    </button>
                  </div>
                </Col>
              </Row>
              <br />
              <Row className="container-col">
                <Col md={8} className="mt-1 right-table-field">
                  <label className="pl-4">
                    {selectedProduct?.last_so_info}
                  </label>
                </Col>
                <Col md={2}>
                  <label className="mt-2 label" style={{ fontSize: "14px" }}>
                    <input
                      type="checkbox"
                      value="advancedMode"
                      checked={fullShipping === 1}
                      onChange={handleChangeFullShipping}
                    />
                    {` `}Full Shipment
                  </label>
                </Col>
                <Col md={2}>
                  <label className="mt-2 label" style={{ fontSize: "14px" }}>
                    <input
                      type="checkbox"
                      value="advancedMode"
                      checked={advancedMode === 1}
                      onChange={handleChangeAdvancedMode}
                    />
                    {` `}Advanced Mode
                  </label>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center table-container-sale"
              >
                <div className="m-0 p-0">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr className="table-sale-tr">
                        <th style={{ width: "80px" }}>CODE</th>
                        <th style={{ width: "320px" }}>PRODUCT</th>
                        <th style={{ width: "60px" }}>UNIT</th>
                        <th style={{ width: "65px" }}>QTY</th>
                        <th style={{ width: "80px" }}>PRICE</th>
                        <th style={{ width: "75px" }}>DISC</th>
                        <th style={{ width: "75px" }}>TOTAL</th>
                        <th style={{ width: "130px" }}>REQ DATE</th>
                        {advancedMode === 1 && (
                          <>
                            <th style={{ width: "90px" }}>SUPPLIER</th>
                            <th style={{ width: "65px" }}>SHIP QTY</th>
                            <th style={{ width: "60px" }}>SPC QTY</th>
                          </>
                        )}
                        <th style={{ width: "180px" }}>NOTES</th>
                        <th style={{ width: "35px" }}>DEL</th>
                      </tr>
                    </thead>
                    <tbody className="pos-table-body">
                      {CardList?.map((item, index) => (
                        <tr key={index}>
                          <td onClick={() => handleToggle(item)}>
                            {item.code}
                          </td>
                          <td onClick={() => handleToggle(item)}>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {defaultImageMode &&
                                imageMode &&
                                (item.image || item.image_url) && (
                                  <div
                                    className="image flex gap-4"
                                    style={{
                                      maxWidth: "72px",
                                      height: "72px",
                                      flex: "0 0 20%",
                                    }}
                                  >
                                    <img
                                      className="rounded-xl"
                                      src={
                                        item.image_url
                                          ? `${item.image_url}`
                                          : `data:image/jpeg;base64,${item.image}`
                                      }
                                      alt={`Product ${item.code}`}
                                    />
                                  </div>
                                )}
                              <div
                                style={{
                                  flex:
                                    defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                      ? "0 0 80%"
                                      : "0 0 100%",
                                  paddingTop:
                                    !(
                                      defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                    ) && "8px",
                                  paddingBottom:
                                    !(
                                      defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                    ) && "7px",
                                  alignSelf: "center",
                                }}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  {truncate(
                                    item.name,
                                    defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                      ? 38
                                      : 44
                                  )}
                                </div>
                                <div>
                                  {truncate(
                                    item.details,
                                    defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                      ? 78
                                      : 88
                                  )}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>{item.unit}</td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="quantity"
                                type="number"
                                step="1.00"
                                min="0"
                                value={item.quantity}
                                onClick={() =>
                                  handleInputClick("quantity", index)
                                }
                                onChange={(e) =>
                                  handleQuantityChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="unit_price"
                                type="number"
                                step="1.00"
                                min="0"
                                value={item.unit_price}
                                onClick={() =>
                                  handleInputClick("unit_price", index)
                                }
                                onChange={(e) =>
                                  handleUnitPriceChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="discount"
                                min="0"
                                max={item.unit_price}
                                type="number"
                                step="1.00"
                                value={item.discount}
                                onClick={() =>
                                  handleInputClick("discount", index)
                                }
                                onChange={(e) =>
                                  handleDiscountChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>{formatCurrency(item.total)}</td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="req_date"
                                type="datetime-local"
                                value={item.req_delivery_date}
                                onChange={(e) =>
                                  handleChangeReqDate(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          {advancedMode === 1 && (
                            <>
                              <td>{item.supplier_name}</td>
                              <td>
                                <div className="centered-input">
                                  <input
                                    className="input"
                                    id="shipment"
                                    type="number"
                                    min="0"
                                    max={item.quantity}
                                    step="1.00"
                                    value={item.shipment}
                                    disabled={fullShipping === 1}
                                    onClick={() =>
                                      handleShipmentClick("shipment", index)
                                    }
                                    onChange={(e) =>
                                      handleShipmentChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="centered-input">
                                  <input
                                    //disabled={ppo_id}
                                    disabled
                                    className="input"
                                    id="spec_order"
                                    type="number"
                                    min="0"
                                    max={item.quantity}
                                    step="1.00"
                                    value={item.spec_qty}
                                    onClick={() =>
                                      handleSpecQtyClick("spec_qty", index)
                                    }
                                    onChange={(e) =>
                                      handleSpecQtyChange(index, e.target.value)
                                    }
                                  />
                                </div>
                              </td>
                            </>
                          )}
                          <td>
                            <div className="centered-input">
                              <textarea
                                className="textarea"
                                id="notes"
                                type="text"
                                maxLength={250}
                                value={item.notes}
                                onClick={() => handleInputClick("notes", index)}
                                onChange={(e) =>
                                  handleNotesChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <button onClick={() => handleDeleteClick(index)}>
                              ❌
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center table-container-sale1"
              >
                <table className="borderless w-100 h-100">
                  <tbody>
                    <tr>
                      <td
                        className="table-sum-label"
                        style={{ paddingTop: "8px" }}
                      >
                        SUB TOTAL:
                      </td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor, paddingTop: "8px" }}
                      >
                        {formatCurrency(total_amount)}
                      </td>
                      <td
                        className="table-grand-sum"
                        rowSpan="8"
                        style={{ backgroundColor: currentColor }}
                      >
                        <div className="tgs-label">
                          BALANCE DUE
                          <br />
                          <span className="tgs-value">
                            {formatCurrency(amount_pend)}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">DISCOUNT:</td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor }}
                      >
                        {formatCurrency(totaldiscount)}
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">TAX:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"%"}</label>
                        <input
                          id="tax"
                          type="number"
                          step="1"
                          min="0"
                          max="100"
                          className="input table-sum-tb"
                          value={tax}
                          onClick={() => handleInputClick("tax", -2)}
                          onChange={handleChangeTax}
                          style={{ color: currentColor }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">SHIPPING:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"$"}</label>
                        <input
                          type="number"
                          name="shipment"
                          min="0"
                          step="1.00"
                          value={projectname2}
                          onChange={handleChangeProjectName2}
                          onClick={() => handleInputClick("shipment1", -3)}
                          className="input table-sum-tb"
                          style={{ marginLeft: "13px", color: currentColor }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">AMOUNT PAID:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"$"}</label>
                        <input
                          type="number"
                          name="amount_paid"
                          min="0"
                          step="1.00"
                          disabled={
                            c_type_id === 1600
                              ? true
                              : paym === 1
                              ? true
                              : false
                          }
                          value={amount_paid}
                          onChange={handleChangeAmountPaid}
                          onClick={() => handleInputClick("amount_paid", -4)}
                          className="input table-sum-tb"
                          style={{
                            marginLeft: "13px",
                            color: currentColor,
                            background:
                              (c_type_id === 1600 || paym === 1) && "lightgray",
                          }}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td className="table-sum-label">RECEIVED IN:</td>
                      <td className="table-sum-cash">
                        <button
                          style={{
                            verticalAlign: "middle",
                            fontSize: "calc(0.4vw + 11px)",
                          }}
                          onClick={handlePaymentToggle}
                        >
                          <FcInfo />
                        </button>
                        <select
                          className="select table-sum-tb"
                          disabled={paym === 1 ? true : false}
                          style={{
                            color: currentColor,
                            marginLeft: "3px",
                            background: paym === 1 && "lightgray",
                          }}
                          value={acc_to}
                          onChange={handleAccToChange}
                        >
                          {getacc_tos.map((item) => (
                            <option key={item.account_id}>{item.name}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">GRAND TOTAL:</td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor }}
                      >
                        {formatCurrency(grandtotal)}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="table-sum-label"
                        style={{ marginBottom: "8px" }}
                      >
                        TOTAL ITEMS:
                      </td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor, marginBottom: "8px" }}
                      >
                        {total_item || 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleSaleOrderClick}
                  >
                    <div className="action-btn">SAVE</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">SAVE & PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleNewClick}
                  >
                    <div className="action-btn">NEW</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleClearClick}
                  >
                    <div className="action-btn">CLEAR</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleStatusClick}
                  >
                    <div className="action-btn">{OrderStatus}</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleBackClick}
                  >
                    <div className="action-btn">EXIT</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ paddingLeft: "16px", paddingRight: "16px" }}
              >
                <Col md={6} className="container-col right-table-field">
                  <label>Ship Method:</label>
                  <input
                    type="text"
                    name="shipmethod"
                    placeholder="Ship-Method"
                    value={shipmethod}
                    onChange={handleChangeShipMethod}
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Tracking No:</label>
                  <input
                    type="text"
                    name="tracking_no"
                    value={trackingno}
                    onChange={handleChangeTrackingNo}
                    placeholder="Tracking No."
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Contact:</label>
                  <input
                    type="text"
                    name="project name"
                    value={projectname}
                    onChange={handleChangeProjectName}
                    placeholder="Contact"
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Customer PO:</label>
                  <input
                    type="text"
                    name="Customer_po"
                    value={projectname1}
                    onChange={handleChangeProjectName1}
                    placeholder="Customer PO"
                    className="input"
                  />
                </Col>
                <Col
                  md={12}
                  className="container-col right-table-field"
                  style={{ paddingTop: "4px", paddingBottom: "16px" }}
                >
                  <textarea
                    placeholder="Sales Order Note"
                    id="noteTextarea"
                    value={note}
                    onChange={handleChangeNote}
                    className="textarea"
                  />
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                {keypadButtons.map((number, index) => (
                  <Col md={4} className="container-col" key={index}>
                    <Card
                      className="keypad-button1"
                      style={{
                        border: "1px solid " + currentColor,
                        color: currentColor,
                      }}
                      key={number}
                      onClick={() => handleKeypadClick(number)}
                    >
                      {number}
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          {/* {toggle && (
            <div className="overlay1">
              <Sidebar
                close={() => setToggle(false)}
                product_id={productID}
                store_id={store_id_param}
              />
            </div>
          )} */}
        </Row>
      </Container>
    </div>
  );
};
export default EditSaleOrder;
